import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  LockOutlined,
  PlusOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Popconfirm,
  Avatar,
  Layout,
  Table,
  Tag,
  Input,
  Flex,
  Switch,
  Modal,
  Tooltip,
  Row,
  Col,
  Select,
  TimePicker,
  Spin,
  Form,
} from "antd";
import {
  ALL_ROOMS,
  DELETE_ROOMS,
  EDIT_GROUP_ID,
  EDIT_ROOMS_BY_GROUP,
  EDIT_STATUS_ROOMS,
  GENERATE_GROUP_ID,
  IMAGE_BASE_URL,
} from "../../constants/api";
import {
  CURRENCY,
  getServiceLabel,
  OTA_SERVICE_TYPE,
} from "../../constants/constent";
import { AutoComplete } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import LS_SERVICE from "../../utils/localStorage";
import dayjs from "dayjs";

function RoomTable() {
  const { Content } = Layout;
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  const [groupOptions, setGroupOptions] = useState([]);

  const [isGroupModalVisible, setIsGroupModalVisible] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [newGroupId, setNewGroupId] = useState("");

  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [form] = Form.useForm();

  const updateData = (values) => {
    setLoading(true);
    const data = {
      ...values,
    };
    if (values.room_check_in) {
      data.room_check_in = dayjs(values.room_check_in).add(330, "minutes");
    }
    if (values.room_check_out) {
      data.room_check_out = dayjs(values.room_check_out).add(330, "minutes");
    }

    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        setIsUpdateModalVisible(false);
        form.resetFields();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_ROOMS_BY_GROUP, data, successFn, errorFn);
  };
  useLayoutEffect(() => {
    getData();
  }, []);

  const updateStatus = (values) => {
    setLoading(true);
    const jsonData = {
      id: values.id,
      booking_enable: values.booking_enable,
    };

    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getData();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_STATUS_ROOMS, jsonData, successFn, errorFn);
  };

  const handleGroupChange = () => {
    if (!selectedRoom) return;
    const data = {
      id: selectedRoom.id,
      group_id: newGroupId,
    };
    setLoading(true);
    postAPI(
      EDIT_GROUP_ID,
      data,
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          setIsGroupModalVisible(false);
          getData();
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message || "Update failed");
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Something went wrong");
      }
    );
  };
  const handleGenerateGroupId = () => {
    const successFn = function (data) {
      if (data?.status === true && data?.groupId) {
        setNewGroupId(data.groupId);
      }
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Failed to generate Group ID");
    };
    getAPI(GENERATE_GROUP_ID, successFn, errorFn, {});
  };

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        const uniqueGroups = [];
        const seen = new Set();

        data.data.forEach((row) => {
          if (!seen.has(row.group_id)) {
            seen.add(row.group_id);
            uniqueGroups.push({ value: String(row.group_id) });
          }
        });

        setGroupOptions(uniqueGroups);

        const roomData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          group_id: row.group_id,
          Name: row.room_name,
          ota_room_type: row.ota_room_type,
          ota_room_service: getServiceLabel(row.ota_room_service),
          Price: `${CURRENCY} ${row.room_amt}`,
          RoomNo: row.room_no,
          Category: <Tag color="processing">{row.room_category.title}</Tag>,
          Booked: (
            <Tag color={row.is_booked ? `error` : `green`}>
              {row.is_booked ? `Booked` : `Booking Open`}
            </Tag>
          ),
          Facility: (
            <Flex gap="4px 0" wrap>
              {row.room_facility.map((item) => (
                <Tag color="processing">{item.facility.title}</Tag>
              ))}
            </Flex>
          ),
          Image: (
            <Avatar.Group shape="square">
              {row.room_images.map((item) => (
                <Avatar
                  shape="square"
                  src={IMAGE_BASE_URL + item.image.filePath}
                />
              ))}
            </Avatar.Group>
          ),
          BookingActive: (
            <Tag color={`${row.booking_enable === 1 ? "green" : "error"}`}>
              {row.booking_enable === 1 ? "Active" : "Disabled"}
            </Tag>
          ),
          Action: (
            <Row gutter={[16, 16]}>
              {LS_SERVICE.get("user_type") === "superAdmin" && (
                <>
                  <Col xs={24} sm={12} md={16}>
                    <Tooltip title="Toggle Booking">
                      <Switch
                        loading={loading}
                        disabled={loading || row.is_booked}
                        defaultChecked={row.booking_enable === 1}
                        onChange={(e) =>
                          updateStatus({ id: row.id, booking_enable: e })
                        }
                      />
                    </Tooltip>
                  </Col>

                  <Col xs={24} sm={12} md={10}>
                    <Tooltip title="Copy Room">
                      <Button
                        icon={<CopyOutlined />}
                        loading={loading}
                        disabled={loading}
                        onClick={() => navigate("/room/add/" + row.room_no)}
                      />
                    </Tooltip>
                  </Col>

                  <Col xs={24} sm={12} md={10}>
                    <Tooltip title="Change Group">
                      <Button
                        icon={<SwapOutlined />}
                        loading={loading}
                        disabled={loading}
                        onClick={() => {
                          setSelectedRoom(row);
                          setNewGroupId(row.group_id);
                          setIsGroupModalVisible(true);
                        }}
                      />
                    </Tooltip>
                  </Col>
                </>
              )}

              <Col xs={24} sm={12} md={10}>
                <Tooltip title="Block / Unblock Room">
                  <Button
                    icon={<LockOutlined />}
                    loading={loading}
                    disabled={loading}
                    onClick={() => navigate("/room/blocked/" + row.id)}
                  />
                </Tooltip>
              </Col>

              <Col xs={24} sm={12} md={10}>
                <Tooltip title="Edit Room">
                  <Button
                    icon={<EditOutlined />}
                    loading={loading}
                    disabled={loading}
                    onClick={() => navigate("/room/edit/" + row.room_no)}
                  />
                </Tooltip>
              </Col>

              {LS_SERVICE.get("user_type") === "superAdmin" && (
                <Col xs={24} sm={12} md={10}>
                  <Tooltip title="Delete Room">
                    <Popconfirm
                      title="Delete the room?"
                      description="Are you sure you want to delete this room?"
                      onConfirm={() => deleteData(row.id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        icon={<DeleteOutlined />}
                        loading={loading}
                        disabled={loading || row.is_booked}
                        danger
                      />
                    </Popconfirm>
                  </Tooltip>
                </Col>
              )}
            </Row>
          ),
        }));
        setState(roomData);
        setFilteredData(roomData);
        setLoading(false);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    getAPI(ALL_ROOMS, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = {
      id: values,
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getData();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_ROOMS, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (room) =>
        room.Name.toLowerCase().includes(value.toLowerCase()) ||
        room.RoomNo.toString().includes(value)
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Group",
      dataIndex: "group_id",
      width: 120,
    },
    {
      title: "Image",
      dataIndex: "Image",
      width: 50,
    },
    {
      title: "Category",
      dataIndex: "Category",
      width: 50,
    },
    {
      title: "Service",
      dataIndex: "ota_room_service",
      width: 50,
    },
    {
      title: "Facility",
      dataIndex: "Facility",
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "Name",
      width: 150,
    },
    {
      title: "Room-No",
      dataIndex: "RoomNo",
      width: 150,
    },
    {
      title: "Price",
      dataIndex: "Price",
      width: 150,
    },
    {
      title: "Booked",
      dataIndex: "Booked",
      width: 150,
    },
    {
      title: "Booking Enable",
      dataIndex: "BookingActive",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Manage Rooms"
            extra={
              <Space>
                <Input
                  placeholder="Search by Name or Room No"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                {LS_SERVICE.get("user_type") === "superAdmin" ? (
                  <>
                    <Button onClick={() => navigate("/room/add")}>
                      Add <PlusOutlined />
                    </Button>
                    <Button onClick={() => setIsUpdateModalVisible(true)}>
                      Update <EditOutlined />
                    </Button>
                  </>
                ) : (
                  <></>
                )}
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <Modal
          title="Change Group"
          open={isGroupModalVisible}
          onCancel={() => setIsGroupModalVisible(false)}
          onOk={handleGroupChange}
          okText="Update Group"
        >
          <p>
            Current Group ID: <strong>{selectedRoom?.group_id}</strong>
          </p>
          <AutoComplete
            options={groupOptions}
            style={{ width: "100%" }}
            value={newGroupId}
            onChange={(value) => setNewGroupId(value)}
            placeholder="Enter or select Group ID"
            filterOption={(inputValue, option) =>
              option?.value?.toLowerCase().includes(inputValue.toLowerCase())
            }
          >
            <Input
              placeholder="Enter or select Group ID"
              suffix={
                <ReloadOutlined
                  onClick={() => setNewGroupId(handleGenerateGroupId())}
                  style={{ cursor: "pointer", color: "#1890ff" }}
                  title="Generate new Group ID"
                />
              }
            />
          </AutoComplete>
        </Modal>
        <Modal
          destroyOnClose={true}
          title="Update Room By Group"
          open={isUpdateModalVisible}
          onCancel={() => setIsUpdateModalVisible(false)}
          onOk={() => form.submit()}
          okText="Update All"
        >
          <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={updateData}>
              <Form.Item
                name="group_id"
                label="Group ID"
                rules={[{ required: true, message: "Group ID is required!" }]}
              >
                <Select
                  showSearch
                  allowClear
                  placeholder="Select a Group ID"
                  optionFilterProp="label"
                  options={groupOptions}
                  style={{ width: "100%" }}
                />
              </Form.Item>

              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item name="occupancy" label="Occupancy" rules={[]}>
                    <Input type="text" placeholder="Occupancy" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="room_amt" label="Room Amount" rules={[]}>
                    <Input type="text" placeholder="Room Amount" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="room_check_in"
                    label="Room Check In"
                    style={{ width: "100%" }}
                    rules={[]}
                  >
                    <TimePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="room_check_out"
                    label="Room Check Out"
                    style={{ width: "100%" }}
                    rules={[]}
                  >
                    <TimePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>

                {/* <Col span={12}>
                  <Form.Item
                    name="ota_room_service"
                    label="OTA Room Service"
                    rules={[]}
                  >
                    <Select
                      showSearch
                      placeholder="Select a OTA Room Service"
                      optionFilterProp="label"
                      options={OTA_SERVICE_TYPE}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="ota_rate"
                    label="OTA Default Rate"
                    rules={[]} // optional
                  >
                    <Input type="text" placeholder="OTA Default Rate" />
                  </Form.Item>
                </Col> */}
              </Row>
            </Form>
          </Spin>
        </Modal>

        <LayoutFooter />
      </Layout>
    </>
  );
}

export default RoomTable;
